import { ref } from 'vue';

// Which JR kanban page the chat pane shows. Board chips (Print jobs,
// PO pending, …) switch it; every request reloads the frame, since staff may
// have navigated elsewhere inside the JR page.
const kanbanPath = ref('/print-jobs');
const kanbanRequest = ref(0);

export function useS3Kanban() {
  const showKanbanPage = path => {
    kanbanPath.value = path;
    kanbanRequest.value += 1;
  };
  return { kanbanPath, kanbanRequest, showKanbanPage };
}
